import React from "react";

const PartnerGrid = ({ partners, getLogo }) => {
  const isDesktop = window.innerWidth >= 1024;

  const styles = {
    partnerGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "20px",
      marginTop: "30px",
    },

    partnerCard: {
      textAlign: "center",
    },

    partnerLogoWrapper: {
      height: "80px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    partnerLogo: {
      maxHeight: "60px",
      maxWidth: "100%",
      objectFit: "contain",
      filter: "grayscale(100%)",
      opacity: 0.85,
      transition: "all .2s ease",
    },

    partnerName: {
      fontSize: "13px",
      marginTop: "8px",
    },
  };

  return (
    <div
      style={{
        ...styles.partnerGrid,
        gridTemplateColumns: isDesktop ? "repeat(3, 1fr)" : "repeat(2, 1fr)",
      }}
    >
      {partners.map((partner, i) => (
        <div key={i} style={styles.partnerCard}>
          <div style={styles.partnerLogoWrapper}>
            <img
              src={getLogo(partner.image)}
              alt={partner.name}
              loading="lazy"
              style={styles.partnerLogo}
              onMouseEnter={(e) => {
                e.currentTarget.style.filter = "grayscale(0)";
                e.currentTarget.style.opacity = 1;
                e.currentTarget.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.filter = "grayscale(100%)";
                e.currentTarget.style.opacity = 0.85;
                e.currentTarget.style.transform = "scale(1)";
              }}
            />
          </div>

          <div style={styles.partnerName}>{partner.name}</div>
        </div>
      ))}
    </div>
  );
};

export default PartnerGrid;
